import React from 'react'
import './style.sass'

import { Header } from 'pages/Header'
import { Footer } from 'pages/Footer'
import Error from 'components/Error/ErrorProduct'

export default function Error404 () {
    return(
        <>
            <Header type='complete' />
            <main>
                <section>
                    <div className="errorPage">
                        <Error />
                    </div>
                </section>
            </main>
            <Footer type='complete'/>
        </>
    )
}